import { render, staticRenderFns } from "./registerDc.vue?vue&type=template&id=5efd2ff1&scoped=true"
import script from "./registerDc.vue?vue&type=script&lang=js"
export * from "./registerDc.vue?vue&type=script&lang=js"
import style0 from "./registerDc.vue?vue&type=style&index=0&id=5efd2ff1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efd2ff1",
  null
  
)

export default component.exports